import { accessRole } from "../../../../helpers/access_role";

import React, { Component, Fragment, createRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner
} from "reactstrap";

import TableActiveComponent from "./Components/TablePrimaryComponent";
import TableSecondaryComponent from "./Components/TableSecondaryComponent";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import DataTableBloc from "./Blocs/DataTableBloc";
import apiResponse from "../../../../services/apiResponse";

class IndexView extends Component {
  dataTableBloc = new DataTableBloc();

  constructor(props) {
    super(props);

    this.state = {
      userdata: null,
      employeeSeleted: null,
      currentRole: null,
      activeTab: "1",
      checkPKPM : false,
      loadingTable : true, // Ubah ke true sebagai initial state,
      position_name_new : null,
    };

    this.activeRef = createRef();
    this.secondaryRef = createRef();
    this.inactiveRef = createRef();
  }

  componentDidMount() {
    const storedUserdata = JSON.parse(localStorage.getItem("userdata"));
    const storedEmployeeSelected = JSON.parse(
      localStorage.getItem("employeeSelected")
    );
    const currentRole = localStorage.getItem("currentRoleName");
    let user_uuid = null;
    if (currentRole === "Administrator") {
      user_uuid = storedEmployeeSelected?.employee_uuid;
    } else {
      user_uuid = storedUserdata?.employee_uuid;
    }
    console.log(user_uuid)
    this.dataTableBloc.fetchgetuserpkpm({
      uuid : user_uuid
    })
    this.dataTableBloc.fetchgetuserpkpmChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: true, // Tetap true saat initial
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response.result;
          let position_name = response.position_name?.toLowerCase()
          let position_grade = response.position_grade
          console.log(position_name)
          console.log(position_grade)
          const checkPKPM = position_name && position_name.includes("penata kelola penanaman modal") && [8, 10, 12, 14].includes(position_grade);
          console.log(checkPKPM)
          this.setState({
            loadingTable: false, // Set false setelah data berhasil dimuat
            checkPKPM : checkPKPM,
            position_name_new : position_name
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingTable: false, // Set false juga saat error
          });
          break;
        default:
          break;
      }
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  reloadActiveRef = () => {
    if (this.activeRef.current) {
      this.activeRef.current.setTokenAPI();
    }
  };

  reloadInactiveRef = () => {
    if (this.activeRef.current) {
      this.activeRef.current.setTokenAPI();
    }
  };

  reloadSecondaryRef = () => {
    if (this.secondaryRef.current) {
      this.secondaryRef.current.setTokenAPI();
    }
  };

  LoadingState = () => (
    <Container fluid>
      <Row>
        <Col xs="12">
          <PegawaiSideBar active="riwayat_angkakredit" />
          
          <Card className="pegawai-rightbar">
            <CardBody>
              <div
                style={{
                  padding: "80px 0",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
                <h5 className="mt-4 text-muted">Harap tunggu sedang mengambil data...</h5>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );

  render() {
    if (this.state.loadingTable) {
      return this.LoadingState();
    }  

    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <PegawaiSideBar active="riwayat_angkakredit" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: true,
                        })}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          {this.state.checkPKPM ? "PKPM" : "Non PKPM"}
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  
                  
                 

                  <TabContent activeTab="1" className="p-3 text-muted">
                    {this.state.checkPKPM ? (
                      <TabPane tabId="1">
                        <TableSecondaryComponent
                          ref={this.secondaryRef}
                          handleInactiveSuccess={this.reloadInactiveRef}
                          position_name_new={this.state.position_name_new}
                        />
                        
                      </TabPane>
                    ) : (
                      <TabPane tabId="1">
                        <TableActiveComponent
                          ref={this.activeRef}
                          handleInactiveSuccess={this.reloadSecondaryRef}
                          position_name_new={this.state.position_name_new}
                        />
                      </TabPane>
                    )}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;